
import React from 'react';
import { AlertTriangle, Trash2 } from 'lucide-react';

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  theme: 'dark' | 'light';
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ isOpen, onClose, onConfirm, title, message, theme }) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    // ACCIÓN INSTANTÁNEA: Primero cerrar modal, luego disparar el borrado
    onClose();
    setTimeout(() => onConfirm(), 0);
  };

  const themeClasses = {
    overlay: "fixed inset-0 bg-black/70 backdrop-blur-md z-[200] flex items-center justify-center p-4 animate-in fade-in duration-300",
    container: `${theme === 'dark' ? 'bg-[#1a1c22] border-[#2d3139]' : 'bg-white border-slate-200'} border w-full max-w-sm rounded-[2rem] shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200`,
    textMain: theme === 'dark' ? 'text-white' : 'text-slate-900',
    textMuted: theme === 'dark' ? 'text-slate-400' : 'text-slate-500',
  };

  return (
    <div className={themeClasses.overlay}>
      <div className={themeClasses.container}>
        <div className="p-8 text-center">
          <div className="w-20 h-20 bg-rose-500/10 rounded-full flex items-center justify-center mx-auto mb-6 border border-rose-500/20">
            <AlertTriangle size={36} className="text-rose-500" />
          </div>
          <h2 className={`text-2xl font-black mb-3 tracking-tight ${themeClasses.textMain}`}>{title}</h2>
          <p className={`${themeClasses.textMuted} text-sm leading-relaxed px-4`}>{message}</p>
        </div>
        
        <div className={`flex items-center p-6 gap-4 ${theme === 'dark' ? 'bg-black/20' : 'bg-slate-50'}`}>
          <button 
            onClick={onClose}
            className={`flex-1 py-4 rounded-2xl text-[10px] font-black uppercase tracking-[0.2em] transition-all ${theme === 'dark' ? 'bg-white/5 text-slate-400 hover:bg-white/10' : 'bg-white border border-slate-200 text-slate-600 hover:bg-slate-50'}`}
          >
            Cancelar
          </button>
          <button 
            onClick={handleConfirm}
            className={`flex-1 py-4 rounded-2xl bg-rose-600 hover:bg-rose-500 text-white text-[10px] font-black uppercase tracking-[0.2em] transition-all shadow-xl shadow-rose-600/20 flex items-center justify-center space-x-2`}
          >
            <Trash2 size={16} />
            <span>Eliminar</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
